import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "edit-groups" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_props_table = _resolveComponent("props-table")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_collapse, {
      activeKey: _ctx.currentKey,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentKey) = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editGroups, (item, index) => {
          return (_openBlock(), _createBlock(_component_a_collapse_panel, {
            key: `item-${index}`,
            header: item.text
          }, {
            default: _withCtx(() => [
              _createVNode(_component_props_table, {
                props: item.props,
                onChange: _ctx.handleChange
              }, null, 8, ["props", "onChange"])
            ]),
            _: 2
          }, 1032, ["header"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["activeKey"])
  ]))
}